/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// document.addEventListener('variant:changed', function(event) {
//    var variant = event.detail.variant; // Gives you access to the whole variant details
//   console.log('variant changed', variant);
//  });

document.addEventListener("DOMContentLoaded", function () {
    const addToCart = document.querySelector(".custom_productmain  .ProductForm__AddToCart");
    const buttonInitialPosition = addToCart.getBoundingClientRect().top + window.scrollY; // Store original position
    let isSticky = false; // Track sticky state

    function handleScroll() {
        const currentScrollY = window.scrollY;

        if (currentScrollY > buttonInitialPosition && !isSticky) {
            // Scrolling down → Make button sticky
            addToCart.classList.add("sticky");
            setTimeout(() => addToCart.classList.add("show"), 200); // Delay to trigger animation
            isSticky = true;
        } 
        else if (currentScrollY <= buttonInitialPosition && isSticky) {
            // Scrolling up → Remove sticky smoothly
            addToCart.classList.remove("show");
            setTimeout(() => addToCart.classList.remove("sticky"), 400); // Wait for animation to finish
            isSticky = false;
        }
    }

    window.addEventListener("scroll", handleScroll);
});



